import quicklink from 'quicklink/dist/quicklink';

(() => {
    // quicklink();
})();
